import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  changeScreenOrientation,
} from "../7screen/redux/ScreensCommon/actions";
import "./Main.css";
import SidebarTabs from "app/components/SidebarTabs";

import Screen1 from "./Screen1/Screen1";
import Screen2 from "./Screen2/Screen2";
import Screen3 from "./Screen3/Screen3";
import Screen4 from "./Screen4/Screen4";
import Screen5 from "./Screen5/Screen5";
import Screen6 from "./Screen6/Screen6";
import Screen7 from "./Screen7/Screen7";

class SevenScreen extends Component {
  state = { height: 1080, width: 1920 };

  componentWillMount() {
    // this.scaleScreens()
  }

  scaleScreens() {
    const { innerWidth: currentWidth, innerHeight: currentHeight } = window;
    const requiredWidth = 1920;
    const requiredHeight = 1080;
    const ratio = requiredWidth / requiredHeight;
    const currentRatio = currentWidth / currentHeight;
    let h = currentHeight;
    let w = currentWidth;
    if (currentRatio > ratio) {
      w = h * ratio;
    } else if (currentRatio < ratio) {
      h = w / ratio;
    }

    this.setState({ height: h, width: w });
  }

  render() {
    return (
      <div className={this.props.orientationHorizontal ? "main-container-horizontal" : "main-container-vertical"} id="helios-screen-wrapper">
        <SidebarTabs changeScreenOrientation={this.props.changeScreenOrientation} />
        <div className={this.props.orientationHorizontal ? "screen-horizontal screen1" : "screen-vertical screen1"}>
          <Screen1 />
        </div>
        <div className={this.props.orientationHorizontal ? "screen-horizontal" : "screen-vertical"}>
          <Screen2 />
        </div>
        <div className={this.props.orientationHorizontal ? "screen-horizontal" : "screen-vertical"}>
          <Screen3 />
        </div>
        <div className={this.props.orientationHorizontal ? "screen-horizontal" : "screen-vertical"}>
          <Screen4 />
        </div>
        <div className={this.props.orientationHorizontal ? "screen-horizontal" : "screen-vertical"}>
          <Screen5 />
        </div>
        <div className={this.props.orientationHorizontal ? "screen-horizontal" : "screen-vertical"}>
          <Screen7 />
        </div>
        <div className={this.props.orientationHorizontal ? "screen-horizontal" : "screen-vertical"}>
          <Screen6 />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeScreenOrientation,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SevenScreen);
